import React, { useEffect, useRef } from 'react';
import './MobileFiltersDrawer.css';

/**
 * 移动端侧滑抽屉
 * props:
 *  - open: boolean         是否打开
 *  - onClose: () => void   关闭回调
 *  - children: ReactNode   内容（一般放筛选项）
 */
const MobileFiltersDrawer = ({ open, onClose, children }) => {
  const startX = useRef(null);
  const currentX = useRef(null);
  const panelRef = useRef(null);

  // 打开时锁住 body 滚动
  useEffect(() => {
    const body = document.body;
    if (open) body.classList.add('no-scroll');
    else body.classList.remove('no-scroll');
    return () => body.classList.remove('no-scroll');
  }, [open]);

  // 右滑关闭（仅在打开时挂载监听）
  useEffect(() => {
    if (!open) return;
    const panel = panelRef.current;
    if (!panel) return;

    const onTouchStart = (e) => {
      startX.current = e.touches[0].clientX;
      currentX.current = startX.current;
    };

    const onTouchMove = (e) => {
      currentX.current = e.touches[0].clientX;
      const delta = currentX.current - startX.current; // 右滑为正
      if (delta > 0) {
        panel.style.transition = 'none';
        panel.style.right = `${-Math.min(delta, panel.offsetWidth)}px`;
      }
    };

    const onTouchEnd = () => {
      const delta = (currentX.current ?? 0) - (startX.current ?? 0);
      panel.style.transition = '';
      panel.style.right = '';
      if (delta > 80) onClose?.();
      startX.current = null;
      currentX.current = null;
    };

    panel.addEventListener('touchstart', onTouchStart, { passive: true });
    panel.addEventListener('touchmove', onTouchMove, { passive: true });
    panel.addEventListener('touchend', onTouchEnd);

    return () => {
      panel.removeEventListener('touchstart', onTouchStart);
      panel.removeEventListener('touchmove', onTouchMove);
      panel.removeEventListener('touchend', onTouchEnd);
    };
  }, [open, onClose]);

  return (
    <>
      <div
        className={`drawer-overlay ${open ? 'open' : ''}`}
        onClick={onClose}
        aria-hidden={!open}
      />
      <aside
        className={`drawer-panel ${open ? 'open' : ''}`}
        ref={panelRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="drawer-title"
      >
        <div className="drawer-header">
          <div id="drawer-title" className="drawer-title">筛选</div>
          <button className="drawer-close" onClick={onClose} aria-label="Close filters">
            关闭
          </button>
        </div>
        {children}
      </aside>
    </>
  );
};

export default MobileFiltersDrawer;
